<template>
	<div id="dataSelectors">
		<form class="select-category d-flex flex-column">
			<label class="custom-control custom-checkbox">
				<input type="checkbox" class="custom-control-input" v-model="formParams.categories"
					   @change="dataChanged(false)" value="dental_technology_type">
				<span class="custom-control-indicator indicator-1"></span> {{ translations.dental_technology }}
			</label>

			<label class="custom-control custom-checkbox">
				<input type="checkbox" class="custom-control-input" v-model="formParams.categories"
					   @change="dataChanged(false)" value="anesthetic_technology_type">
				<span class="custom-control-indicator indicator-2"></span> {{ translations.anaesthetic_technology }}
			</label>
		</form>

		<form action="" class="d-flex flex-column align-items-baseline my-4" v-if="load">
			<div class="form-control-wrap  my-1">
				<select v-if="continents.length > 0" @change="dataChanged(true)" class="selectpicker form-control"
						v-model="formParams.continent" id="select1">
					<option :value="null">{{ translations.select_region }}</option>
					<option v-for="continent in continents" :value="continent.id">{{ continent.name[locale] }}</option>
				</select>
			</div>
			<div class="form-control-wrap my-1" v-if="countries.length > 0">
				<select @change="dataChanged(false)" class="selectpicker countriesselect form-control"
						v-model="formParams.country" id="select2">
					<option :value="null">{{ translations.select_country }}</option>
					<option v-for="country in countries" :value="country.id">{{ country.name[locale] }}</option>
				</select>
			</div>
		</form>
	</div>
</template>

<script>

	import {mapActions, mapGetters, mapMutations} from "vuex";

	export default {
		name: "DataSelectors",
		props: ['translations','locale'],
		data() {
			return {
				categories: {},
				countries: {},
				continents: {},
				formParams: {
					categories: ["dental_technology_type", "anesthetic_technology_type"],
					country: null,
					continent: null,
				},
				load: false
			}
		},
		computed: {
			...mapGetters(['getSelectedContinent']),
		},
		methods: {
			...mapActions(['fetchOfficesData']),
			...mapMutations(['setSelectedContinent', "setChangeContinent"]),
			loadCategories() {
				axios.get('/categories').then((response) => {
					this.categories = response.data;

					this.setCategories();
				})
			},
			async loadEntities() {
				await axios.get('/continents').then((data) => {
					this.continents = data.data;
					this.load = true
				});
			},
			getFormData() {
				return JSON.parse(JSON.stringify(this.formParams));
			},
			dataChanged(continentsChanged) {
				if (continentsChanged) {
					this.setChangeContinent(true)
					this.setSelectedContinent(this.getFormData().continent)
					$(function () {
						$('.countriesselect').selectpicker('destroy');
					});

					this.formParams.country = null;
					axios.get('/countries', {
						params: {
							continent: this.getFormData().continent,
						}
					}).then((response) => {
						this.countries = response.data;
						this.fetchOfficesData(this.getFormData());
						$(function () {
							$('.countriesselect').selectpicker();
						});
					});
				} else {
					this.setChangeContinent(false)
					this.fetchOfficesData(this.getFormData());
				}
			}
		},
		async mounted() {
			await this.loadEntities();
			$('#select1').val(3);
			$('.selectpicker').selectpicker('refresh')
			this.formParams.continent = 3
			setTimeout( () => {
				this.dataChanged(true)
			} , 500)
		}
	}
</script>

<style scoped>

</style>
